// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"92849849","905":"4eb739b3","970":"48e8d4a3"}[chunkId] + ".chunk.css";
};